import { AxiosResponse } from "axios";
import apiClient, { IError } from "../core/HttpClient";
import { User } from "../models";

export default class AuthService {
 
  
  // This class can be used to handle authentication-related logic
  // such as login, logout, and user session management.

  // Example method for logging in a user
  async login(data: {
    phone: string;    
    rememberMe: boolean;
  }): Promise<void> {
    // Logic to authenticate the user
    return apiClient.post("/Auth/login", data);
  }

  // Example method for logging out a user
  async logout(): Promise<void> {
    // Logic to log out the user
    return apiClient.post("/Auth/logout");
  }

  async checkEmailExist(email: string): Promise<boolean> {
    // Logic to check if the email already exists
    const response = await apiClient.get(`/Auth/check-email?email=${email}`);
    return response.data.exists;
  }

  async register(data: {
    name: string;
    phone: string;    
  }): Promise<AxiosResponse<{verificationId: string}|IError>> {
    // Logic to register a new user
    return apiClient.post<{verificationId: string}>("/Auth/register", data);
  }
  
  verifyEmail(data: { email: string; code: string; }) {       
    return apiClient.post("/Auth/verify-email", data);
    
  }
  forgetPassword(data: { email: string; }) {
    return apiClient.post("/Auth/forgot-password", data);
  }
   resetPassword(data: { email: string; token: string; newPassword: string; }) {      
    return apiClient.post("/Auth/reset-password", data);
  }

  sendVeruficationCode(data: { phone: string;}) {
    return apiClient.post<{verificationId: string}>("/Auth/send-phone-verification", data);
  }

  verifyPhone(data: { phone: string; verificationId: string; token: string; rememberMe: boolean; JWTonly: boolean; }) {
    return apiClient.post<{verificationId: string}>("/Auth/verify-phone", data);
  }
  checkPhoneExist(phone: string) {
    return apiClient.get<{exists: boolean}>(`/Auth/check-phone?phone=${phone}`);
  }
}